export const TOKEN = 'token'
// token 时间戳
export const TIME_STAMP = 'timeStamp'
// 超时时长(毫秒) 两小时
export const TOKEN_TIMEOUT_VALUE = 2 * 3600 * 1000
// 国际化
export const LANG = 'language'
// 主题色 保存的key
export const MAIN_COLOR = 'mainColor'
// 默认主题色
export const DEFAULT_COLOR = '#409EFF'
// tags
export const TAGS_VIEW = 'tagsView'
